import {get, post2, post, request, getFileStream} from './base'

const USER_LIST = '/api/userInfo/list'
const POINT_CHARGE = '/api/userInfo/pointCharge'
const POINT_CONSUME = '/api/userInfo/deduct'
const POINT_RECORD = '/api/userInfo/pointRecord'
const EDIT = '/api/userInfo/edit'
const OWNER_INFO = '/api/userInfo/ownerInfo'

export default {
    getUserList( params) {
        return get(USER_LIST,params);
    },
    pointCharge( params) {
        return post(POINT_CHARGE, params)
    },
    deduct( params) {
        return post(POINT_CONSUME, params)
    },
    getPointRecord( params) {
        return get(POINT_RECORD, params)
    },
    edit( params) {
        return post(EDIT, params)
    },
    getOwnerInfo( params) {
        return get(OWNER_INFO, params)
    },


    login(data) {
        return request('/auth/login', data, 'post')
    },
    queryPage(params) {
        return request('/user/queryPage', params, 'get')
    },
    editPocketBind(data) {
        return request('/user/editPocketBind', data, 'post')
    },
    export(data) {
        return getFileStream('/user/export', data, 'get')
    },
    updatePrintTime(id) {
        return request('/user/updatePrintTime/' + id, null, 'post')
    },
    queryPhotos(params) {
        return request('/user/queryPhotos', params, 'get')
    }
}
